//@ts-nocheck
import request from '../request';

export const searchStockPhotos = ({
  query = '',
  orientation = 'wide',
  page = 1,
  perPage = 18,
  signal
}) =>
  request
    .get('photos/search', {
      params: { query, orientation, page, per_page: perPage },
      signal
    })
    .then((response) => response.data);

export const importStockPhoto = ({
  provider,
  providerPhotoId,
  pathReference,
  tripId,
  lineItemId
}) =>
  request
    .post('photos/import', {
      provider,
      providerPhotoId,
      pathReference,
      tripId,
      lineItemId
    })
    .then((response) => response.data);

export const copyTripServicePhotoToLibrary = ({ tripId, fileName }) =>
  request
    .post('photos/copy-to-library', { tripId, fileName })
    .then((response) => response.data);
